import { formatNumber } from '../../../../core/formatter/formatNumber';
import { i18n } from '../../../../i18n/i18n';
import * as React from 'react';
import { SectionStyle } from '../../../../helpers/SectionStyle';

interface BenchmarkSVGProps extends React.ClassAttributes<any> {
    data?: any;
    rangeStart: number;
    rangeEnd: number;
    value?: number;
    average: number;
    einheit: string;
}

export class BenchmarkSVG extends React.Component<BenchmarkSVGProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        const width = 500;
        const height = 40;
        const rangeEnd: number = +this.props.rangeEnd || 0;
        const rangeStart: number = +this.props.rangeStart || 0;
        const value: number = +this.props.value || 0;
        const average: number = +this.props.average || 0;
        const einheit: string = this.props.einheit || '';
        const value_range: number = Math.abs(rangeEnd - rangeStart);
        const fact: number = value_range !== Infinity ? (value_range ? width / value_range : 0) : 0;
        const pos_avg: number = (average !== Infinity || rangeStart !== Infinity)
            ? ((average - rangeStart) * fact)
            : 0;
        let pos: number = (value - rangeStart) * fact;

        if (isNaN(pos) || pos < 0) {
            pos = 0;
        }
        let overflowX: number = width + 40 - pos - (118 / 2) - 20;
        const pos_box: number = overflowX < 0 ? pos + overflowX : pos;
        overflowX = width + 40 - pos_avg - (118 / 2) - 20;
        const pos_avg_box: number = overflowX < 0 ? pos_avg + overflowX : pos_avg;
        const color: any = SectionStyle.getSectionColors() || {};
        const [backgroundColorSectionTable, fontSizeHeadline] = new SectionStyle().getPropertyValues([
            '--color-section-table-background', '--font-size-headline'
        ]);
        const noData: string = i18n('Für diesen Wert{{lb}}haben sie noch keine{{lb}}Daten eingegeben', 'sys');

        return (
            <svg
                id='Entwicklungsplan_SVG'
                viewBox={`0 0 ${width + 40} ${height + 110}`}
                // Firefox does not support drawing SVG images to canvas unless the svg file has width/height attributes
                // on the root <svg> element and those width/height attributes are not percentages.
                // style={{ width: `${width}px`, height: `${height}px` }}
                width={width + 80}
                height={height + 110}
                // Für SVG to PNG, Font und Font-Family beibehalten
                fontSize={12}
                fontFamily='Arial, sans-serif'
            >
                <defs>
                    <linearGradient
                        id='linear-gradient'
                        gradientUnits='userSpaceOnUse'
                        x1={40} y1={20} x2={width + 40} y2={20}
                    >
                        <stop offset='0%' stopColor={color.datenauswertung} stopOpacity='100%' />{/*#00aa44*/}
                        <stop offset='45%' stopColor='#e9e925' stopOpacity='100%' />
                        <stop offset='50%' stopColor='#e9e925' stopOpacity='100%' />
                        <stop offset='100%' stopColor='#dc001f' stopOpacity='100%' />
                    </linearGradient>
                </defs>
                <rect x={40} y={60} width={width} height={height} fill='url(#linear-gradient)' />
                <rect x={pos_avg - 1 + 40} y={60} width={2} height={height} fill={backgroundColorSectionTable} />
                <text fill={color.datenauswertung} x={40} y={height + 107}>{/*#00aa44*/}
                    {`${formatNumber(rangeStart, rangeStart > 1000 ? 0 : 2)} ${einheit} (min)`}
                </text>
                <text fill='#dc001f' textAnchor='end' x={width + 40} y={height + 107}>
                    {`${formatNumber(rangeEnd, rangeEnd > 1000 ? 0 : 2)} ${einheit} (max)`}
                </text>
                <rect x={pos_avg_box - 18} y={height + 70} ry={6} rx={6} width={116} height={20} strokeWidth={2} stroke={color.informationen_hilfe} fill={color.informationen_hilfe} />
                <text textAnchor='middle' x={pos_avg_box + 40} y={height + 85} fill='#fff'>
                     &empty;&nbsp;{`${formatNumber(average, average > 999 ? 0 : 2)} ${einheit}`}
                </text>
                <>
                    <rect x={pos_box - 18} y={5} ry={6} rx={6} width={116} height={45} strokeWidth={2} stroke={color.datenauswertung} fill={color.datenauswertung} />
                    <polygon points={`${pos - 1 + 40 + 1 - 8},50 ${pos - 1 + 40 + 1},58 ${pos - 1 + 40 + 1 + 8},50`} fill={color.datenauswertung}/>
                    <rect x={pos - 1 + 40} y={60} width={2} height={height} fill={backgroundColorSectionTable} />
                    <polygon points={`${pos_avg - 1 + 40 + 1 - 8},${height + 70} ${pos_avg - 1 + 40 + 1},${height + 70 - 8} ${pos_avg - 1 + 40 + 1 + 8},${height + 70}`} fill={color.informationen_hilfe}/>
                    {(this.props.value !== undefined && !isNaN(this.props.value))
                        ? [
                            <text textAnchor='middle' x={pos_box + 40} y={25} fontSize={fontSizeHeadline} fontWeight={600} fill='#fff' key='value'>
                                {i18n('Ihr Betrieb', 'sys')}:
                            </text>,
                            <text textAnchor='middle' x={pos_box + 40} y={40} fill='#fff' key='value-einheit'>
                                {`${formatNumber(this.props.value, this.props.value > 1000 ? 0 : 2)} ${einheit}`}
                            </text>
                        ]
                        : <g>
                            {noData.split('{{lb}}').map((line: string, index: number) =>
                                <text textAnchor='middle' fontSize={11} fill='#fff' x={pos + 40} y={18 + (index * 13)}>{line}</text>
                            )}
                        </g>
                    }
                </>
            </svg>
        );
    }
}
/*
<stop offset='10%' stopColor='#88ff88' stopOpacity='70%' />
<stop offset='45%' stopColor='#ddff44' stopOpacity='70%' />
<stop offset='55%' stopColor='#ffdd44' stopOpacity='70%' />
<stop offset='90%' stopColor='#ff8888' stopOpacity='70%' />
*/
